const zhCN = {
  userLogin: '用户登录',

  usernameTxt: '账户名',
  usernameBlank: '请输入帐户名！',

  passwordTxt: '密码',
  passwordBlank: '请输入密码！',
  passwordMinLength: '密码最小 8 位！',

  varifyCodeTxt: '验证码',
  varifyCodeBlank: '请输入验证码！',

  loginBtn: '用户登录',
  registerBtn: '用户注册',
  forgetPasswordBtn: '忘记密码',

  loginSuccess: '欢迎回来',
  loginFail: '登录失败'
}

const enUS = {
  userLogin: 'Login',

  usernameTxt: 'Username',
  usernameBlank: 'Username can\'t be blank!',

  passwordTxt: 'Password',
  passwordBlank: 'Password can\'t be blank!',
  passwordMinLength: 'Password minimum 8 characters!',

  varifyCodeTxt: 'Verification Code',
  varifyCodeBlank: 'Verification Code can\'t be blank!',

  loginBtn: 'Login',
  registerBtn: 'Register',
  forgetPasswordBtn: 'Forget Password',

  loginSuccess: 'Welcome back!',
  loginFail: 'Login failed!'
}

export default { zhCN, enUS }